/* oxlint-disable react/react-compiler -- Existing code is not yet compatible with React Compiler checks. */
import clsx from 'clsx';
import type * as React from 'react';

import { BLOCK_HEADING_1, BLOCK_HEADING_2, BLOCK_HEADING_3 } from '@gitbook/doc-core';
import type { BlockProps } from '@gitbook/slate-react';

import { usePlainMarkdownStyle } from '../usePlainMarkdownStyle';
import { BasicBlockWrapper } from './BasicBlockWrapper';

/**
 * Basic renderer for an heading block.
 */
export function BasicBlockHeading(props: BlockProps): React.ReactElement {
    const { node, children } = props;

    const { textStyle } = usePlainMarkdownStyle();
    const Tag = getHTMLTag(node.type);

    return (
        <BasicBlockWrapper {...props}>
            <Tag className={clsx(fontSizes[node.type], textStyle)}>{children}</Tag>
        </BasicBlockWrapper>
    );
}

/** Get the HTML tag for an heading block */
function getHTMLTag(nodeType: string): 'h1' | 'h2' | 'h3' {
    switch (nodeType) {
        case BLOCK_HEADING_1:
            return 'h1';
        case BLOCK_HEADING_2:
            return 'h2';
        case BLOCK_HEADING_3:
            return 'h3';
        default:
            throw new Error(`invalid node type (${nodeType}) for heading`);
    }
}

const fontSizes = {
    [BLOCK_HEADING_1]: 'text-content-heading-medium md:text-content-heading-large',
    [BLOCK_HEADING_2]: 'text-content-heading-small md:text-content-heading-medium',
    [BLOCK_HEADING_3]: 'text-content-paragraph md:text-content-heading-small',
};
